import { render, staticRenderFns } from "./iconLegend.vue?vue&type=template&id=4ea969e8&scoped=true"
import script from "./iconLegend.vue?vue&type=script&lang=js"
export * from "./iconLegend.vue?vue&type=script&lang=js"
import style0 from "./iconLegend.vue?vue&type=style&index=0&id=4ea969e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea969e8",
  null
  
)

export default component.exports